/*
* 系统公共store
*/
const state = {
    isAdmin: false,
    admin: false,
    isRootAdmin: false,
    loginedUserInfo: null,
    isPrivilegedPerson: false // 是否特权人
};
const mutations = {
    // 设置登陆后台的权限
    setIsAdmin(state, params) {
        state.isAdmin = params;
    },
    setIsPrivilegedPerson(state, params) {
        state.isPrivilegedPerson = params;
    },
    // 设置是否为系统管理员
    setAdmin(state, params) {
        state.admin = params;
    },
    // 设置是否为超级管理员
    setRootAdmin(state, params) {
        state.isRootAdmin = params;
    },
    // 设置用户信息
    setUserInfo(state, params) {
        state.loginedUserInfo = params;
    }
};
const actions = {};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
